import { render, staticRenderFns } from "./admin-nav-tabs.vue?vue&type=template&id=7029e5d0&scoped=true&"
import script from "./admin-nav-tabs.vue?vue&type=script&lang=ts&"
export * from "./admin-nav-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./admin-nav-tabs.vue?vue&type=style&index=0&id=7029e5d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029e5d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
